import { generatePath } from 'react-router-dom';

import { NBA_PLAY_PRO_COMPETITION_DETAILS_LEADERBOARDSLUG_REWARDS } from '@sorare/core/src/constants/__generated__/routes';

export const generateRewardsPath = (leaderboardSlug = '') => {
  return generatePath(
    NBA_PLAY_PRO_COMPETITION_DETAILS_LEADERBOARDSLUG_REWARDS,
    { leaderboardSlug }
  );
};
